import React, {Component} from 'react';
import Skeleton from 'react-loading-skeleton';
import {Container} from "reactstrap";
import assets from "../../../../util/assets";
import "./index.css"
import EmptyComponent from "../../../../components/empty";
import {connect} from "react-redux";
import * as actions from "../../../../actions";
import library from "../../../../util/clipstore/broadcaster/library";
import api from "../../../../util/clipstore/broadcaster/subscription_api";
import SubscriberListItem from "../../../../components/clipstore/broadcaster/library/profile/subscribers";

const getListArray = (props) => {
    return (
        props.get_my_subscribers &&
        props.get_my_subscribers.hasOwnProperty("payload") &&
        props.get_my_subscribers.payload &&
        props.get_my_subscribers.payload.hasOwnProperty("data") &&
        props.get_my_subscribers.payload.data.hasOwnProperty("data") &&
        Array.isArray(props.get_my_subscribers.payload.data.data) &&
        props.get_my_subscribers.payload.data.data.length > 0
    )
}

class BroadcasterSubscribersContainer extends Component {

    componentDidMount() {
        api.getMySubscribersAPI(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        library.handleAPIResponse(nextProps, "get_my_subscribers", () => {

        }, () => {
        }, () => {

        }, true, true);
        
    }

    render() {

        if (this.props.get_my_subscribers.isFetching) {
            return (
                <Container className="broadcaster-profile-subscriber-container">
                    {
                        [1, 2, 3, 4, 5].map((value,index) => {
                            return (
                                <div style={{background:'#f7f7f7'}} key={`subscription-list-item-${index}`}>
                                    <Skeleton style={{height: 88, marginBottom: 8}}/>
                                </div>
                            )
                        })
                    }
                </Container>
            );
        } else if (getListArray(this.props)) {
            return (
                <div className="broadcaster-profile-subscriber-container">
                    {
                        this.props.get_my_subscribers.payload.data.data.map((item, index) => {
                            return (
                                <SubscriberListItem
                                    key={`subscription-list-item-${index}`}
                                    item={item}/>
                            )
                        })
                    }
                </div>
            );
        } else {
            return (
                <Container>
                    <EmptyComponent
                        img={assets.empty.content_zero}
                        title={" No subscribers found"}
                        description={"Sorry there is no subscribers found at this moment."}/>
                </Container>
            );
        }

    }
}

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        get_my_subscribers: state.get_my_subscribers,
    };
}

export default connect(mapStateToProps, actions)(BroadcasterSubscribersContainer);
